import { useTranslation } from "react-i18next";
import api from "@/lib/api";

/**
 * Small globe-icon language toggle. Persisted in localStorage under `progres_lang`
 * and (if user is logged in) synced to the backend via `/api/auth/set-language`
 * so emails and invoices respect the user's language.
 * Cycles PL ↔ EN.
 */
export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "pl").slice(0, 2);
  const next = current === "pl" ? "en" : "pl";
  const label = next.toUpperCase();

  const toggle = async () => {
    await i18n.changeLanguage(next);
    // Best-effort sync to backend; ignore 401 (unauthenticated visitors).
    try {
      await api.post("/auth/set-language", { language: next });
    } catch (_e) {
      // not logged in or offline — localStorage is still updated by LanguageDetector.
    }
  };

  if (variant === "landing") {
    return (
      <button
        onClick={toggle}
        data-testid="lang-switcher"
        aria-label="Change language"
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-stone-300 text-stone-700 hover:bg-stone-100 text-[11px] font-semibold tracking-wide transition-colors"
      >
        <span aria-hidden>🌐</span>
        <span>{label}</span>
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      data-testid="lang-switcher"
      aria-label="Change language"
      title={next === "en" ? "English" : "Polski"}
      className="inline-flex items-center gap-1 px-2 py-1 rounded-lg border border-stone-200 bg-white/70 hover:bg-white text-stone-700 text-[11px] font-semibold tracking-wide transition-colors"
    >
      <span aria-hidden>🌐</span>
      <span className="tabular">{label}</span>
    </button>
  );
}
